import SharingMenu from './SharingMenu';

export default SharingMenu;
